import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dt-table-empty-content',
  templateUrl: './table-empty-content.component.html',
  styleUrls: ['./table-empty-content.component.scss'],
})
export class TableEmptyContentComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
